export default __webpack_public_path__ + "static/ecole-969ca4c2b3b0399c978fbae640b6eda2.png";